import img1 from "../assets/industries/1SugarIndustrySolutions.jpg"
import img2 from "../assets/industries/2CementIndustrySolutions.jpg"
import img3 from "../assets/industries/3OilGasIndustrySolutions.jpg"
import img4 from "../assets/industries/4SteelIndustrySolutions.jpg"
import img5 from "../assets/industries/5PlasticPackagingIndustrySolutions.jpg"
import img6 from "../assets/industries/6PowerBackupSolutions.jpg"

const industries = [
  {
    id: 1,
    name: "Sugar Industry Solutions",
    image: img1,
    description: `
    EAVER supplies specialized products and services for the sugar industry, designed to achieve higher production efficiency with lower power consumption and uninterrupted power availability.

    Our solutions focus on energy optimization, reliability, and continuous operations, helping sugar plants improve productivity while reducing operational costs.
    `,
  },
  {
    id: 2,
    name: "Cement Industry Solutions",
    image: img2,
    description: `
    EAVER provides integrated electrical and automation solutions for the cement industry, with a strong focus on process control, energy efficiency, and productivity improvement.

    By deploying VFD drives, LV panels (PCC, MCC, APFC), and motor control solutions, EAVER helps cement plants achieve precise control of critical processes such as crushing, grinding, material handling, and kiln operations.

    Our solutions enable:
    •	Reduced power consumption through optimized motor speed control
    •	Improved process stability and reliability
    •	Higher productivity with controlled energy usage
    •	Smooth and continuous plant operations

    EAVER’s engineering products and services are designed to support the demanding operational needs of modern cement plants while ensuring long-term efficiency and performance.
    `,
  },
  {
    id: 3,
    name: "Oil & Gas Industry Solutions",
    image: img3,
    description: `
    EAVER supplies a wide range of electrical products and engineering services to oil and gas manufacturing plants, ensuring reliable and safe power distribution for critical operations.

    Our solutions support:
    •	Continuous and stable power supply
    •	Optimized energy usage
    •	Enhanced operational efficiency
    •	Safety and protection of electrical equipment

    We help oil and gas facilities maintain uninterrupted operations while improving overall productivity and equipment longevity.
    `,
  },
  {
    id: 4,
    name: "Steel Industry Solutions",
    image: img4,
    description: `
    EAVER provides comprehensive electrical and automation solutions for the steel industry, supporting energy-intensive and continuous production processes.

    Our solutions include LV Panels (PCC, MCC, APFC), Power & Distribution Transformers, VFD drives, motors, and control systems, designed to deliver stable power distribution, precise process control, and high operational reliability.

    EAVER solutions help steel plants achieve:
    •	Optimized power consumption in rolling mills and furnaces
    •	Improved productivity and process efficiency
    •	Reliable and uninterrupted operations
    •	Enhanced equipment protection and safety

    We support critical steel plant applications such as furnaces, rolling mills, conveyors, cranes, cooling systems, and auxiliary utilities.
    `,
  },
  {
    id: 5,
    name: "Plastic & Packaging Industry Solutions",
    image: img5,
    description: `
    EAVER provides reliable electrical and automation solutions for the plastic and packaging industries, where precision, speed, and energy efficiency are critical.

    Our solutions include LV Panels (PCC, MCC, APFC), Power & Distribution Transformers, VFD drives, motors, and control systems, designed to ensure stable power distribution, precise process control, and uninterrupted operations.

    EAVER solutions help plastic and packaging plants achieve:
    •	Reduced energy consumption in extrusion, molding, and packaging lines
    •	Improved production efficiency and throughput
    •	Consistent process control and product quality
    •	Safe and reliable plant operations
    `,
  },
  {
    id: 6,
    name: "Power Backup Solutions",
    image: img6,
    description: `
    EAVER provides comprehensive power backup solutions to ensure stable, uninterrupted, and reliable power for industrial, commercial, and critical infrastructure applications.

    AVR & UPS Solutions
    •	Automatic VoLVage Regulators (AVR)
    o	Maintain stable voLVage output for generators and electrical systems
    o	Protect equipment from voLVage fluctuations and surges
    o	Compatible with industrial and commercial generators

    •	Uninterruptible Power Supply (UPS)
    o	Provides backup power during outages or disturbances
    o	Ensures continuous operation of critical systems and equipment
    o	Available in online, offline, and hybrid configurations

    Batteries & Battery Chargers
    •	Industrial & Stationary Batteries
    o	Long-life batteries for UPS systems, power plants, and substations
    o	Designed for continuous and standby operations

    •	Battery Chargers
    o	Intelligent chargers for safe, efficient battery maintenance
    o	Optimize battery performance, prevent overcharging, and extend battery life

    Key Benefits
    •	Reliable and uninterrupted power for critical systems
    •	Protection against voLVage fluctuations, surges, and blackouts
    •	Optimized performance and longevity of batteries and electrical assets
    •	Seamless integration with UPS, generators, and AVRs
    `,
  },
];

export default industries;